const getMenuContent = () => {
    const userData = JSON.parse(localStorage.getItem('authUser'));
    const userType = userData?.userType;

    // Common menu items for all users
    const commonMenuItems = [
        {
            title: 'JOB CARD',
            to: 'JobCardForm',
        },
        {
            title: 'CLOSING REPORT',
            to: 'ClosingReport',
        }
    ];

    // Admin menu items (F_UserType = 1) - structured into sections
    const adminMenuItems = [
        {
            title: 'FIRM MASTER',
            to: 'FirmMaster',
        },
        {
            title: 'FIRM TYPE MASTER',
            to: 'FirmTypeMaster',
        },
        {
            title: 'FIRM SHIFT TIME MAPPING',
            to: 'FirmShiftTimeMapping',
        },
        {
            title: 'CONCERN TYPE MASTER',
            to: 'ConcernTypeMaster',
        },
        {
            title: 'PREMISES TYPE MASTER',
            to: 'PremisesTypeMaster',
        },
        {
            title: 'DESIGNATION MASTER',
            to: 'DesignationMaster',
        },
        {
            title: 'DEPARTMENT MASTER',
            to: 'DepartmentMaster',
        },
        {
            title: 'WORKER CATEGORY',
            to: 'WorkerCategory',
        },
        {
            title: 'EMPLOYEE TYPE MASTER',
            to: 'EmployeeTypeMaster',
        },
        {
            title: 'REASON TO LEFT MASTER',
            to: 'ReasonOfLeftMaster',
        },
        {
            title: 'LEAVE MASTER',
            to: 'LeaveMaster',
        },
        {
            title: 'ALLOWANCE MASTER',
            to: 'AllowanceMaster',
        },
        {
            title: 'DEDUCTION MASTER',
            to: 'DeductionMaster',
        },
        {
            title: 'EXTRA PAY MASTER',
            to: 'ExtraPayMaster',
        },
    ];

    // Admin reporting items
    const adminReportingItems = [];

    // Supervisor menu items (F_UserType = 2)
    const supervisorMenuItems = [
        {
            title: 'MACHINE COMPONENT REPORT',
            to: 'MachineComponentMapReport',
        },
        {
            title: 'CREATE AL SLIP',
            to: 'AddALSlip',
        },
        {
            title: 'AL SLIP',
            to: 'ALSlip',
        },
        {
            title: 'WOOD ISSUE',
            to: 'AddWoodIssue',
        },
        {
            title: 'ADD OTHER SLIP',
            to: 'AddOtherSlip',
        },
        {
            title: 'SUPERVISOR ENTRY',
            to: 'SupervisorEntry',
        },
        {
            title: 'MANUAL REPORT ENTRY',
            to: 'ManualReportEntry',
        }
    ];

    // Operator menu items (F_UserType = 3)
    const operatorMenuItems = [
        {
            title: 'MACHINE COMPONENT REPORT',
            to: 'MachineComponentMapReport',
        }
    ];

    // Return menu items based on user type
    switch (userType) {
        case 1: // Admin
            return { adminMenuItems, adminReportingItems };
        case 2: // Supervisor
            return [...supervisorMenuItems, ...commonMenuItems];
        case 3: // Operator
            return [...operatorMenuItems, ...commonMenuItems];
        default:
            return commonMenuItems;
    }
};

export const getMenuList = () => {
    const userData = JSON.parse(localStorage.getItem('authUser'));
    const userType = userData?.userType;
    const menuData = getMenuContent();

    const baseMenu = [
        {
            title: 'DASHBOARD',
            to: 'dashboard',
        }
    ];

    // Transaction menu items
    const transactionMenuItems = [
        {
            title: 'PAYROLL',
            to: 'Payroll',
        },
        {
            title: 'PAYROLL IMPORT / EXPORT',
            to: 'PayrollImportExport',
        },
    ];

    // Reports menu items
    const reportMenuItems = [
        /*
        {
            title: 'FORM 7 REPORT',
            to: 'Form7Report',
        },
        */
        {
            title: 'PF CHALLAN REPORT',
            to: 'PfChallanReport',
        },
        {
            title: 'PF FORM 11 (NEW JOINING)',
            to: 'PfForm11NewJoining',
        },
        {
            title: 'PF FORM 12',
            to: 'PfForm12Report',
        },
        {
            title: 'PF FORM 9 (REVISED)',
            to: 'Form9RevisedReport',
        },
        {
            title: 'PF DEDUCTION DETAIL',
            to: 'PfDeductionDetail',
        },
        {
            title: 'BONUS REPORT (FORM C)',
            to: 'BonusReport',
        },
        {
            title: 'FORM 6A (REVISED)',
            to: 'Form6AReport',
        },
        {
            title: 'WAGES REGISTER (DEPT-WISE)',
            to: 'WagesRegisterDeptWise',
        },
        {
            title: 'WAGES REGISTER LEGAL (DEPT-WISE)',
            to: 'WagesRegisterLegalDeptWise',
        },
        {
            title: 'WAGES SLIP REPORT',
            to: 'WagesSlipReport',
        },
        {
            title: 'WAGES SLIP (INDIVIDUAL)',
            to: 'WagesSlipIndividual',
        },
        {
            title: 'REGISTER OF ADULT WORKERS (FORM 13)',
            to: 'AdultWorkerRegister',
        },
        {
            title: 'ESI DEDUCTION DETAIL',
            to: 'EsiDeductionDetail',
        },
    ];

    if (userType === 1) { // Admin
        return [
            ...baseMenu,
            {
                title: 'EMPLOYEE MASTER',
                to: 'EmployeeMaster',
                customClass: 'section-header-menu',
            },
            {
                title: 'PAYROLL PARAMETER',
                to: 'PayrollParameter',
                customClass: 'section-header-menu',
            },
            {
                title: 'MASTERS',
                classsChange: 'mm-collapse',
                customClass: 'section-header-menu',
                content: menuData.adminMenuItems
            },
            {
                title: 'TRANSACTION',
                classsChange: 'mm-collapse',
                customClass: 'section-header-menu',
                content: transactionMenuItems
            },
            {
                title: 'REPORTS',
                classsChange: 'mm-collapse',
                customClass: 'section-header-menu',
                content: reportMenuItems
            },
        ];
    } else {
        return [
            ...baseMenu,
            {
                title: 'MENU ITEMS',
                classsChange: 'mm-collapse',
                content: menuData
            }
        ];
    }
};

export const MenuList = getMenuList;